import React, { useState } from "react";
import { Alert } from "@material-ui/lab";
import moment from "moment";
import ChangesMakePayment from "../Changes-Make-Payments/ChangesMakePayment";
function ChangeInRequest(props) {
  const { errMessage, ChangeInRequestConfirmation } = props;

  const { request, bid_Accepted_company } = props.requestData;

  const [isPayment, setIsPayment] = useState(false);

  const { movers, movers_change } = bid_Accepted_company;
  const {
    final_amount,
    final_amount_change,
    s_time,
    s_time_change,
    s_date,
    s_date_change,
    request_timeline_status,
    id,
    discount,
  } = request;

  const handleAccept = () => {
    if (final_amount === final_amount_change || request_timeline_status < 3) {
      ChangeInRequestConfirmation("1", final_amount_change - final_amount);
    } else {
      setIsPayment(true);
    }
  };

  if (isPayment) {
    return (
      <ChangesMakePayment
        id={id}
        amount={final_amount_change - final_amount}
        old_amount={final_amount}
        new_amount={final_amount_change}
        ChangeInRequestConfirmation={ChangeInRequestConfirmation}
        discount={discount}
      />
    );
  }
  return (
    <>
      <div className="row">
        <div className="col-12 col-lg-6" id="onebox">
          <div className=" rounded-box items-info-wrapper mt-2 ">
            <div className="info-header text-center">
              <h6 className="black-color">Previous Request Information</h6>
            </div>
            <div className="info-detail-wrapper p-3 pt-20">
              {/* // */}
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left overline dark-grey-color">
                  Date:
                </div>
                <div className="col-6  black-color">
                  {moment(s_date).format("MMM Do YY")}
                </div>
              </div>
              {/* // */}
              {/* // */}
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left overline dark-grey-color">
                  Time
                </div>
                <div className="col-6  black-color">{s_time}</div>
              </div>
              {/* // */}
              {/* // */}
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left overline dark-grey-color">
                  Movers:
                </div>
                <div className="col-6  black-color">{movers}</div>
              </div>
              {/* // */}
              {/* // */}
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left overline dark-grey-color">
                  Price:
                </div>
                <div className="col-6  black-color">${final_amount}</div>
              </div>
              {/* // */}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 mt-4 mt-lg-0" id="twobox">
          <div className="rounded-box items-info-wrapper mt-2">
            <div className="info-header text-center">
              <h6 className="black-color">
                Changed Request Information
                {/* (+${extra_item_price_change}) */}
              </h6>
            </div>
            {errMessage && (
              <Alert variant="filled" severity="error">
                {errMessage}
              </Alert>
            )}
            <div className="info-detail-wrapper p-3 pt-20">
              {/*  */}
              {/* // */}
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left overline dark-grey-color">
                  Date:
                </div>
                <div className="col-6  black-color">
                  {" "}
                  {moment(s_date_change).format("MMM Do YY")}
                  {/* indicator of change */}
                  {moment(s_date_change).format("MMM Do YY") !==
                    moment(s_date).format("MMM Do YY") && (
                    <span className="light-red-color small-font-size pl-2 pr-2 ">
                      (changed)
                    </span>
                  )}
                </div>
              </div>
              {/* // */}
              {/* // */}
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left overline dark-grey-color">
                  Time
                </div>
                <div className="col-6  black-color">
                  {s_time_change}{" "}
                  {s_time_change !== s_time && (
                    <span className="light-red-color small-font-size pl-2 pr-2 ">
                      (changed)
                    </span>
                  )}
                </div>
              </div>
              {/* // */}
              {/* // */}
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left overline dark-grey-color">
                  Movers:
                </div>
                <div className="col-6  black-color">
                  {movers_change}
                  {movers_change !== movers && (
                    <span className="light-red-color small-font-size pl-2 pr-2 ">
                      (changed)
                    </span>
                  )}
                </div>
              </div>
              {/* // */}
              {/* // */}
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left overline dark-grey-color">
                  Price:
                </div>
                <div className="col-6  black-color">
                  ${final_amount_change}
                  {final_amount_change !== final_amount && (
                    <span className="light-red-color small-font-size pl-2 pr-2 ">
                      (changed)
                    </span>
                  )}
                </div>
              </div>
              {/* // */}
            </div>
          </div>
        </div>

        <div className="col-3"></div>
        <div className="col-6 mt-1  justify-content-center d-flex">
          <button
            className="custom-btn-small custom-buton m-4"
            onClick={handleAccept}
          >
            Accept
          </button>
          <button
            className="custom-btn-small custom-buton m-4"
            onClick={() => ChangeInRequestConfirmation("0")}
          >
            Reject
          </button>
        </div>
        <div className="col-3"></div>
      </div>
    </>
  );
}

export default ChangeInRequest;
